<template>
  <div class="app-container">
    <!-- 搜索条件 -->
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="分账接收方编号">
        <el-input placeholder="请输入分账接收方编号" v-model="filter.payee_no" clearable></el-input>
      </el-form-item>
      <el-form-item label="分账接收方名称">
        <el-input placeholder="请输入分账接收方名称" v-model="filter.payee_name" clearable></el-input>
      </el-form-item>
      <el-form-item label="所属商户">
        <el-input placeholder="请输入所属商户" v-model="filter.merchant_name" clearable></el-input>
      </el-form-item>
      <el-form-item label="支付状态">
        <el-select class="selScale" v-model="filter.pay_status" style="width: 130px">
          <el-option label="--全部--" value=""></el-option>
          <el-option label="未支付" value="0"></el-option>
          <el-option label="已支付" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="支付方式">
        <el-select class="selScale" v-model="filter.pay_type" style="width: 130px">
          <el-option label="--全部--" value=""></el-option>
          <el-option label="手动" value="manual"></el-option>
          <el-option label="自动" value="auto"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="filter.dateRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
      </el-form-item>
    </el-form>

    <!-- 结算记录列表 -->
    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading" highlight-current-row>
      <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
      <el-table-column label="结算单编号" prop="ID" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column label="结算金额" align="right" width="120">
        <template slot-scope="{ row }">
          <span class="settle-amount">{{ formatAmount(row.SetteAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="所属商户名称" prop="merchant_name" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="分账接收方编号" prop="SaccPayeeCode" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="分账接收方名称" prop="SaccPayeeName" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="结算日期" align="center" width="110">
        <template slot-scope="{ row }">{{ formatDateOnly(row.SetteDate) }}</template>
      </el-table-column>
      <!-- <el-table-column label="结算支付编号" prop="BalanceSaccTrade_ID" min-width="150" show-overflow-tooltip></el-table-column> -->
      <el-table-column label="支付状态" align="center" width="100">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="isPaid(row) ? 'success' : 'info'">{{ payStatusText(row) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="支付方式" align="center" width="100">
        <template slot-scope="{ row }">{{ payTypeText(row) }}</template>
      </el-table-column>
      <el-table-column label="创建时间" prop="CreateTime" width="170" align="center"></el-table-column>
      <el-table-column label="更新时间" prop="UpdateTime" width="170" align="center"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="90" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onDetail(row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <!-- 当前搜索条件下的结算金额汇总 -->
      <div class="statistic_left">
        <span class="sbox">
          总结算金额：<span class="bold ssuc">{{ formatAmount(totalSettleAmount) }} 元</span>
        </span>
      </div>
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 结算详情 Drawer（只读） -->
    <el-drawer
      title="分账结算详情"
      :visible.sync="visible.detail"
      direction="rtl"
      :size="drawerSize"
      @closed="onDetailClosed"
    >
      <div class="drawer-container">
        <div class="drawer-body" v-loading="detailLoading">
          <el-descriptions :column="2" border size="small" class="detail-desc">
            <el-descriptions-item label="结算编号">{{ detailData.ID || "-" }}</el-descriptions-item>
            <el-descriptions-item label="结算名称">{{ detailData.SettleName || "-" }}</el-descriptions-item>
            <el-descriptions-item label="结算金额">
              <span class="settle-amount">{{ formatAmount(detailData.SetteAmount) }} 元</span>
            </el-descriptions-item>
            <el-descriptions-item label="所属商户名称">{{ detailData.merchant_name || "-" }}</el-descriptions-item>
            <el-descriptions-item label="分账接收方编号">{{ detailData.SaccPayeeCode || "-" }}</el-descriptions-item>
            <el-descriptions-item label="分账接收方名称">{{ detailData.SaccPayeeName || "-" }}</el-descriptions-item>
            <el-descriptions-item label="结算日期">{{ formatDateOnly(detailData.SetteDate) }}</el-descriptions-item>
            <el-descriptions-item label="结算支付编号">{{ detailData.BalanceSaccTrade_ID || "-" }}</el-descriptions-item>
            <el-descriptions-item label="支付状态">
              <el-tag size="small" :type="isPaid(detailData) ? 'success' : 'info'">
                {{ payStatusText(detailData) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="支付方式">{{ payTypeText(detailData) }}</el-descriptions-item>
            <el-descriptions-item label="交易状态">{{ detailData.saccTradeStatus || "-" }}</el-descriptions-item>
            <el-descriptions-item label="失败说明">{{ detailData.failMessage || "-" }}</el-descriptions-item>
            <el-descriptions-item label="创建时间">{{ detailData.CreateTime || "-" }}</el-descriptions-item>
            <el-descriptions-item label="更新时间">{{ detailData.UpdateTime || "-" }}</el-descriptions-item>
            <el-descriptions-item label="备注" :span="2">{{ detailData.Remark || "-" }}</el-descriptions-item>
            <!-- 支付方式为手动时，展示手动执行支付操作 -->
            <el-descriptions-item v-if="isManualPay(detailData)" label="手动执行支付">
              <el-button type="primary" size="mini" :loading="paying" @click="onManualPay">手动支付</el-button>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div class="drawer-footer">
          <el-button type="primary" @click="visible.detail = false">关闭</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import {
  GetRevenueSharingSettlePageList,
  getSaccSettleOrderStatisticApi,
  GetRevenueSharingSettleDetail,
  ManualPayRevenueSharingSettle
} from "@/api/finance"

export default {
  name: "RevenueSharingSettlement",
  mixins: [pageMixin],
  data() {
    return {
      tableData: [],
      loading: false,
      // 当前搜索条件下的总结算金额
      totalSettleAmount: 0,
      filter: {
        payee_no: "",
        payee_name: "",
        merchant_name: "",
        pay_status: "",
        pay_type: "",
        dateRange: []
      },
      visible: {
        detail: false
      },
      drawerSize: "50%",
      detailLoading: false,
      detailData: {},
      paying: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    buildParams() {
      const [start_time, end_time] =
        this.filter.dateRange && this.filter.dateRange.length === 2 ? this.filter.dateRange : ["", ""]
      return {
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        payee_no: this.filter.payee_no || null,
        payee_name: this.filter.payee_name || null,
        merchant_name: this.filter.merchant_name || null,
        pay_status: this.filter.pay_status === "" ? null : this.filter.pay_status,
        pay_type: this.filter.pay_type || null,
        start_time: start_time || null,
        end_time: end_time || null
      }
    },

    getData() {
      this.loading = true
      GetRevenueSharingSettlePageList(this.buildParams())
        .then((res) => {
          this.tableData = (res && res.data) || []
          this.pageParams.total = (res && (res.total || res.count)) || 0
        })
        .catch(() => {
          this.tableData = []
          this.pageParams.total = 0
        })
        .finally(() => {
          this.loading = false
        })
      // 没当访问第一页数据时，调用一下统计数据的接口
      if(this.pageParams.page === 1){
        getSaccSettleOrderStatisticApi(this.buildParams())
          .then((res) => {
            this.totalSettleAmount = (res && res.TotalSetteAmount) || 0
          })
          .catch(() => {
            this.totalSettleAmount = 0
          })
          .finally(() => {
            
          })
      }
    },

    /* ============ 详情 ============ */
    onDetail(row) {
      this.detailData = { ...row }
      this.drawerSize = this.calcDrawerSize()
      this.visible.detail = true
      this.fetchDetail(row)
    },

    fetchDetail(row) {
      this.detailLoading = true
      GetRevenueSharingSettleDetail({ Id: row.ID, settle_no: row.settle_no })
        .then((res) => {
          const detail = res && res.outputData ? res.outputData : {}
          this.detailData = { ...row, ...detail }
        })
        .catch(() => {
          // 服务端接口暂未实现，使用列表行数据回显，保证前端可正常联调
          this.detailData = { ...row }
        })
        .finally(() => {
          this.detailLoading = false
        })
    },

    onDetailClosed() {
      this.detailData = {}
      this.detailLoading = false
      this.paying = false
    },

    // Drawer 宽度 = 内容界面宽度的 50%
    calcDrawerSize() {
      const contentWidth = (this.$el && this.$el.clientWidth) || window.innerWidth
      return Math.max(Math.floor(contentWidth * 0.5), 320) + "px"
    },

    /* ============ 手动支付 ============ */
    onManualPay() {
      const settleNo = this.detailData.settle_no || ""
      this.$confirm(`确定要对结算单「${settleNo}」执行手动支付吗？`, "手动支付确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.paying = true
          const payload = {
            ID: this.detailData.ID,
            settle_no: this.detailData.settle_no,
            pay_no: this.detailData.pay_no
          }
          return ManualPayRevenueSharingSettle(payload)
            .catch(() => {
              // 服务端接口暂未实现，本地按支付成功处理，保证前端可正常联调
            })
            .finally(() => {
              this.paying = false
            })
        })
        .then(() => {
          this.$message.success("手动支付成功")
          // 本地同步支付状态，等待后端接口就绪后由接口返回结果
          this.detailData.pay_status = 1
          this.detailData.pay_status_name = "已支付"
          this.getData()
        })
        .catch(() => {})
    },

    /* ============ 展示格式化 ============ */
    isPaid(row) {
      if (!row) return false
      if (row.BalanceSaccTrade_ID > 0) return true
      return false
    },

    payStatusText(row) {
      if (!row) return "-"
      //if (row.pay_status_name) return row.pay_status_name
      return this.isPaid(row) ? "已支付" : "未支付"
    },

    isManualPay(row) {
      if (!row) return false
      return String(row.pay_type).toLowerCase() === "manual"
    },

    payTypeText(row) {
      if (!row) return "-"
      if (row.pay_type_name) return row.pay_type_name
      const type = String(row.SaccType).toLowerCase()
      if (type === "1") return "手动"
      if (type === "0") return "自动"
      return row.SaccType || "-"
    },

    formatAmount(val) {
      if (val === null || val === undefined || val === "") return "0.00"
      const num = Number(val)
      if (isNaN(num)) return val
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    // 结算日期只展示年月日
    formatDateOnly(val) {
      if (val === null || val === undefined || val === "") return "-"
      const str = String(val)
      return str.length > 10 ? str.substring(0, 10) : str
    }
  }
}
</script>

<style scoped>
.settle-amount {
  color: #f56c6c;
  font-weight: 600;
}

.drawer-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.drawer-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0 20px;
}

.drawer-footer {
  flex-shrink: 0;
  padding: 12px 20px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}

.detail-desc {
  margin-bottom: 12px;
}

::v-deep .el-drawer__body {
  overflow: hidden;
}
</style>
